import React from "react";
import { Box, Card, CardActionArea, Typography } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { get, isEmpty, minBy } from "lodash";

import { appfrontCdnRoot } from "../../../utils/media";
import NoImageRenderer from "../../no-image-renderer";
import { LOGIN_TYPES } from "../../LoginView";

const FREQUENCY_WORDS = {
  Weekly: "week",
  Monthly: "month",
  Quarterly: "quarter",
  Annually: "year",
};

const SubscribeWidget = ({
  appStyles,
  pageContext,
  widget,
  subscriptionPolicies,
  navigateToTargetOrLoginMobile,
  T,
}) => {
  if (isEmpty(subscriptionPolicies)) {
    return null;
  }

  const policy = minBy(subscriptionPolicies, (p) => Number(get(p, "price", 0)));
  const currencySymbol = get(pageContext, "business.currencySymbol", "$");
  const price = `${currencySymbol}${Number(get(policy, "price", 0)).toFixed(2)}`;
  const paymentFrequency = get(policy, "paymentFrequency");
  const frequencyWord = FREQUENCY_WORDS[paymentFrequency] || paymentFrequency || "";

  const imageKey = get(widget, "media[0].key");
  const isRtl = Boolean(appStyles.rtl);
  const Chevron = isRtl ? ChevronLeft : ChevronRight;

  const handleClick = navigateToTargetOrLoginMobile({
    type: LOGIN_TYPES.SUBSCRIPTION,
    target: "/subscriptions",
  });

  return (
    <Card
      elevation={3}
      style={{
        borderRadius: appStyles.cardBorderRadius,
        background: "#fff",
      }}
    >
      <CardActionArea onClick={handleClick}>
        <Box
          sx={{
            display: "flex",
            flexDirection: isRtl ? "row-reverse" : "row",
            alignItems: "center",
            padding: "12px",
            gap: "12px",
          }}
        >
          <Box
            sx={{
              width: 72,
              height: 72,
              flexShrink: 0,
              borderRadius: "8px",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#f5f5f5",
            }}
          >
            {imageKey ? (
              <img
                src={`${appfrontCdnRoot}/${imageKey}`}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            ) : (
              <NoImageRenderer
                appStyles={appStyles}
                wrapperStyle={{ width: 72, height: 72 }}
                isWidget
              />
            )}
          </Box>

          <Box sx={{ flex: 1, minWidth: 0, textAlign: isRtl ? "right" : "left" }}>
            <Typography
              component="div"
              sx={{
                color: appStyles.actionColor,
                fontWeight: 500,
                fontSize: "13px",
                lineHeight: 1.2,
                marginBottom: "4px",
              }}
            >
              {T("Subscribe and Save")}
            </Typography>
            {!isEmpty(get(policy, "subscriptionTitle")) && (
              <Typography
                component="div"
                sx={{
                  color: "rgba(0, 0, 0, 0.87)",
                  fontWeight: 700,
                  fontSize: "16px",
                  lineHeight: 1.3,
                }}
              >
                {policy.subscriptionTitle}
              </Typography>
            )}
            <Typography
              component="div"
              sx={{
                fontSize: "13px",
                color: "rgba(0, 0, 0, 0.6)",
                lineHeight: 1.2,
                marginTop: "6px",
              }}
            >
              {T(`starting at ${price}${frequencyWord ? ` per ${frequencyWord}` : ""}`)}
            </Typography>
          </Box>

          <Chevron sx={{ color: "rgba(0, 0, 0, 0.4)", flexShrink: 0 }} />
        </Box>
      </CardActionArea>
    </Card>
  );
};

export default SubscribeWidget;
